<template>
  <div class="xsxxxgsq">
    <Header title="学生信息修改申请" type="0" route="/homeIndex"></Header>
    <!-- <NOdata title="暂无学生信息修改申请数据~" v-if="this.recordList.length == 0"></NOdata> -->
    <van-tabs
      ref="vanTabs"
      v-model="active"
      :lazy-render="true"
      @rendered="getActive"
      scrollspy
      sticky
      offset-top="50px"
    >
      <van-tab title="基本信息">
        <div class="xsxxxgsq_info info_person">
          <div class="info_person_img">
            <div v-if="fileList.length > 0 || imgContent" class="img_preview">
              <img :src="imgContent" alt="" />
              <div @click.stop="upload" class="right_icon">
                <van-icon name="photograph" />
              </div>
            </div>
            <van-uploader
              ref="vanUploader"
              :max-count="2"
              v-model="fileList"
              :preview-image="false"
              :after-read="afterRead"
              :disabled="sfkxg !== '1' && !shztshz"
            />
          </div>
          <div class="info_person_main">
            <h3>{{ xsxxMap.xm ? xsxxMap.xm : "-" }}</h3>
            <ul class="xsxxxgsq_info_content">
              <li class="content_item">
                <span>籍贯:</span>
                <p>{{ xsxxMap.jg ? xsxxMap.jg : "-" }}</p>
              </li>
              <li class="content_item">
                <span>证件号:</span>
                <p>{{ xsxxMap.sfzjh ? xsxxMap.sfzjh : "-" }}</p>
              </li>
              <li class="content_item">
                <span>电子邮箱:</span>
                <p>{{ xsxxMap.dzxx ? xsxxMap.dzxx : "-" }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="xsxxxgsq_info">
          <div class="xsxxxgsq_info_header">
            <div class="header_left">
              <h3>基本信息</h3>
            </div>
            <div
              v-if="shztshz"
              class="header_right"
              @click="update('基本信息', 'update')"
            >
              <van-icon name="edit" />
              <span>修改</span>
            </div>
          </div>
          <ul class="xsxxxgsq_info_content">
            <li class="content_item">
              曾用名:
              <p>{{ xsInfoMap.cym ? xsInfoMap.cym : "-" }}</p>
            </li>
            <li class="content_item">
              <span>出生日期:</span>
              <p>
                {{
                  xsInfoMap.csrq
                    ? xsInfoMap.csrq.substr(0, 4) +
                      "年" +
                      xsInfoMap.csrq.substr(4, 2) +
                      "月" +
                      xsInfoMap.csrq.substr(6, 2) +
                      "日"
                    : "-"
                }}
              </p>
            </li>
            <li class="content_item">
              <span>民族:</span>
              <p>{{ xsInfoMap.mzmc ? xsInfoMap.mzmc : "-" }}</p>
            </li>
            <li class="content_item">
              <span>政治面貌:</span>
              <p>{{ xsInfoMap.zzmm ? xsInfoMap.zzmm : "-" }}</p>
            </li>
            <li class="content_item">
              <span>婚姻状况:</span>
              <p>{{ xsInfoMap.hyzkmc ? xsInfoMap.hyzkmc : "-" }}</p>
            </li>
            <li class="content_item">
              <span>邮政编码:</span>
              <p>{{ xsInfoMap.yzbm ? xsInfoMap.yzbm : "-" }}</p>
            </li>
            <li class="content_item">
              <span>电话:</span>
              <p>{{ xsInfoMap.dh ? xsInfoMap.dh : "-" }}</p>
            </li>
            <li class="content_item">
              <span>姓名拼音:</span>
              <p>{{ xsInfoMap.xmpy ? xsInfoMap.xmpy : "-" }}</p>
            </li>
            <li class="content_item">
              <span>血型:</span>
              <p>{{ xsInfoMap.xx ? xsInfoMap.xx : "-" }}</p>
            </li>
            <li class="content_item">
              <span>通讯地址:</span>
              <p>{{ xsInfoMap.txdz ? xsInfoMap.txdz : "-" }}</p>
            </li>
            <li class="content_item">
              <span>火车到站:</span>
              <p>{{ xsInfoMap.hcdz ? xsInfoMap.hcdz : "-" }}</p>
            </li>
            <li class="content_item">
              <span>银行账号:</span>
              <p>{{ xsInfoMap.yhzh ? xsInfoMap.yhzh : "-" }}</p>
            </li>
            <li class="content_item">
              <span>学生备注:</span>
              <p>{{ xsInfoMap.bz ? xsInfoMap.bz : "-" }}</p>
            </li>
            <li class="content_item">
              <span>是否在职:</span>
              <p>{{ xsInfoMap.sfzzmc ? xsInfoMap.sfzzmc : "-" }}</p>
            </li>
            <li class="content_item">
              <span>所属控制批次:</span>
              <p>{{ xsInfoMap.sskzpcmc ? xsInfoMap.sskzpcmc : "-" }}</p>
            </li>
          </ul>
        </div>
      </van-tab>
      <van-tab title="学籍信息">
        <div class="xsxxxgsq_info">
          <div class="xsxxxgsq_info_header">
            <div class="header_left">
              <h3>学籍信息</h3>
            </div>
          </div>
          <ul class="xsxxxgsq_info_content">
            <li class="content_item">
              <span>学号:</span>
              <p>{{ xjInfoMap.xh ? xjInfoMap.xh : "-" }}</p>
            </li>
            <li class="content_item">
              <span>所属院系:</span>
              <p>{{ xjInfoMap.ssyx ? xjInfoMap.ssyx : "-" }}</p>
            </li>
            <li class="content_item">
              <span>所属专业:</span>
              <p>{{ xjInfoMap.sszy ? xjInfoMap.sszy : "-" }}</p>
            </li>
            <li class="content_item">
              <span>所在班级:</span>
              <p>{{ xjInfoMap.bj ? xjInfoMap.bj : "-" }}</p>
            </li>
            <li class="content_item">
              <span>考生号:</span>
              <p>{{ xjInfoMap.ksh ? xjInfoMap.ksh : "-" }}</p>
            </li>
            <li class="content_item">
              <span>学制:</span>
              <p>{{ xjInfoMap.xz ? xjInfoMap.xz : "-" }}</p>
            </li>
            <li class="content_item">
              <span>入学年份:</span>
              <p>{{ xjInfoMap.dqszj ? xjInfoMap.dqszj : "-" }}</p>
            </li>
            <li class="content_item">
              <span>培养层次:</span>
              <p>{{ xjInfoMap.pycc ? xjInfoMap.pycc : "-" }}</p>
            </li>
            <li class="content_item">
              <span>当前所在级:</span>
              <p>{{ xjInfoMap.dqszj ? xjInfoMap.dqszj : "-" }}</p>
            </li>
            <li class="content_item">
              <span>学籍状态:</span>
              <p>{{ xjInfoMap.xjzt ? xjInfoMap.xjzt : "-" }}</p>
            </li>
            <li class="content_item">
              <span>在校状态:</span>
              <p>{{ xjInfoMap.zxzzt ? xjInfoMap.zxzzt : "-" }}</p>
            </li>
            <li class="content_item">
              <span>当前状态:</span>
              <p>{{ xjInfoMap.dqzt ? xjInfoMap.dqzt : "-" }}</p>
            </li>
          </ul>
        </div>
      </van-tab>
      <van-tab title="监护人信息">
        <div class="xsxxxgsq_info">
          <div class="xsxxxgsq_info_header">
            <div class="header_left">
              <h3>监护人信息</h3>
            </div>
            <div
              v-if="shztshz && jhrInfoList.length < 2"
              class="header_right"
              @click="update('监护人信息', 'add')"
            >
              <van-icon name="plus" />
              <span>添加</span>
            </div>
          </div>
          <div
            class="xsxxxgsq_info_item"
            v-for="(item, index) in jhrInfoList"
            :key="index"
            @click="update('监护人信息', 'update', item)"
          >
            <h3>{{ item.xm ? item.xm : "-" }}</h3>
            <ul class="xsxxxgsq_info_content">
              <li class="content_item">
                <span>关系:</span>
                <p>{{ item.gxm ? item.gxm : "-" }}</p>
              </li>
              <li class="content_item">
                <span>证件类型:</span>
                <p>{{ item.zjlxmc ? item.zjlxmc : "-" }}</p>
              </li>
              <li class="content_item">
                <span>证件号码:</span>
                <p>{{ item.sfzjh ? item.sfzjh : "-" }}</p>
              </li>
            </ul>
            <van-icon v-if="shztshz" name="arrow" />
          </div>
        </div>
      </van-tab>
      <van-tab title="家庭成员">
        <div class="xsxxxgsq_info">
          <div class="xsxxxgsq_info_header">
            <div class="header_left">
              <h3>家庭成员</h3>
            </div>
            <div
              v-if="shztshz"
              class="header_right"
              @click="update('家庭成员', 'add')"
            >
              <van-icon name="plus" />
              <span>添加</span>
            </div>
          </div>
          <div
            class="xsxxxgsq_info_item"
            v-for="(item, index) in jtcyInfoList"
            :key="index"
            @click="update('家庭成员', 'update', item)"
          >
            <h3>{{ item.cyxm ? item.cyxm : "-" }}</h3>
            <ul class="xsxxxgsq_info_content">
              <li class="content_item">
                <span>年龄:</span>
                <p>{{ item.age ? item.age : "-" }}</p>
              </li>
              <li class="content_item">
                <span>关系:</span>
                <p>{{ item.gxmc ? item.gxmc : "-" }}</p>
              </li>
              <li class="content_item">
                <span>政治面貌:</span>
                <p>{{ item.zzmmmc ? item.zzmmmc : "-" }}</p>
              </li>
              <li class="content_item">
                <span>工作单位:</span>
                <p>{{ item.gzdw ? item.gzdw : "-" }}</p>
              </li>
              <li class="content_item">
                <span>职业:</span>
                <p>{{ item.zymc ? item.zymc : "-" }}</p>
              </li>
              <li class="content_item">
                <span>工作单位地址电话:</span>
                <p>{{ item.gzdwxq ? item.gzdwxq : "-" }}</p>
              </li>
            </ul>
            <van-icon v-if="shztshz" name="arrow" />
          </div>
        </div>
      </van-tab>
      <van-tab title="家庭住址">
        <div class="xsxxxgsq_info">
          <div class="xsxxxgsq_info_header">
            <div class="header_left">
              <h3>家庭住址</h3>
            </div>
            <div
              v-if="shztshz"
              class="header_right"
              @click="update('家庭住址', 'add')"
            >
              <van-icon name="plus" />
              <span>添加</span>
            </div>
          </div>
          <div
            class="xsxxxgsq_info_item"
            v-for="(item, index) in jtzzInfoList"
            :key="index"
            @click="update('家庭住址', 'update', item)"
          >
            <h3>{{ item.jtzz ? item.jtzz : "-" }}</h3>
            <ul class="xsxxxgsq_info_content">
              <li class="content_item">
                <span>家庭电话:</span>
                <p>{{ item.jtdh ? item.jtdh : "-" }}</p>
              </li>
              <li class="content_item">
                <span>家庭邮政编码:</span>
                <p>{{ item.jtyzbm ? item.jtyzbm : "-" }}</p>
              </li>
              <li class="content_item">
                <span>家庭电子邮箱:</span>
                <p>{{ item.jtdzxx ? item.jtdzxx : "-" }}</p>
              </li>
              <li class="content_item">
                <span>家庭联系人:</span>
                <p>{{ item.jtlxr ? item.jtlxr : "-" }}</p>
              </li>
            </ul>
            <van-icon v-if="shztshz" name="arrow" />
          </div>
        </div>
      </van-tab>
      <van-tab title="简历">
        <div class="xsxxxgsq_info">
          <div class="xsxxxgsq_info_header">
            <div class="header_left">
              <h3>简历</h3>
            </div>
            <div
              v-if="shztshz"
              class="header_right"
              @click="update('简历', 'add')"
            >
              <van-icon name="plus" />
              <span>添加</span>
            </div>
          </div>
          <div
            class="xsxxxgsq_info_item"
            v-for="(item, index) in jlInfoList"
            :key="index"
            @click="update('简历', 'update', item)"
          >
            <h3>{{ item.szdw ? item.szdw : "-" }}</h3>
            <ul class="xsxxxgsq_info_content">
              <li class="content_item">
                <span>起始日期:</span>
                <p>
                  {{
                    item.qsrq
                      ? item.qsrq.substr(0, 4) +
                        "年" +
                        item.qsrq.substr(4, 2) +
                        "月" +
                        item.qsrq.substr(6, 2) +
                        "日"
                      : "-"
                  }}
                </p>
              </li>
              <li class="content_item">
                <span>结束日期:</span>
                <p>
                  {{
                    item.zzrq
                      ? item.zzrq.substr(0, 4) +
                        "年" +
                        item.zzrq.substr(4, 2) +
                        "月" +
                        item.zzrq.substr(6, 2) +
                        "日"
                      : "-"
                  }}
                </p>
              </li>
              <li class="content_item">
                <span>担任职务:</span>
                <p>{{ item.zwmc ? item.zwmc : "-" }}</p>
              </li>
              <li class="content_item">
                <span>证明人:</span>
                <p>{{ item.zmr ? item.zmr : "-" }}</p>
              </li>
              <li class="content_item">
                <span>工作内容:</span>
                <p>{{ item.gznr ? item.gznr : "-" }}</p>
              </li>
            </ul>
            <van-icon v-if="shztshz" name="arrow" />
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="back_top" @click="backTop">
      <van-icon name="back-top" />
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      active: 0,
      fileList: [],
      imgContent: "",
      xsxxMap: {},
      xsInfoMap: {},
      xjInfoMap: {},
      jhrInfoList: [{}, {}],
      jtcyInfoList: [{}, {}],
      jtzzInfoList: [{}, {}],
      jlInfoList: [{}, {}],
      shztshz: false,
      sfkxg: "1"
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.findStudentInfo();
      if (res.code === "1") {
        this.xsxxMap = res.data.xsxxMap;
        this.xsInfoMap = res.data.XsInfoMap;
        this.xjInfoMap = res.data.XjInfoMap;
        this.jhrInfoList = res.data.jhrInfoList;
        this.jtcyInfoList = res.data.jtcyInfoList;
        this.jtzzInfoList = res.data.jtzzInfoList;
        this.jlInfoList = res.data.jlInfoList;
        this.shztshz = res.data.shztshz;
        this.sfkxg = res.data.cloumStatrusList[0].sfkxg;
        this.imgContent = res.data.xsxxMap.zp;
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    getActive() {
      this.active = Number(this.$route.query.active);
      this.$refs.vanTabs.scrollTo(this.active);
    },
    update(title, type, item) {
      if (!this.shztshz) return;
      this.$router.push({
        path: "/xsxxxgsq/update",
        query: {
          title,
          type,
          active: this.active,
          ...item
        }
      });
    },
    backTop() {
      $(".xsxxxgsq")[0].scrollTop = 0;
    },
    async afterRead(file, detail) {
      if (this.fileList.length) {
        this.fileList = [file];
      }
      this.imgContent = file.content;
      const res = await Api.saveXjxx({ file: file.file });
    },
    upload() {
      this.$refs.vanUploader.chooseFile();
    }
  }
};
</script>

<style lang="less" scoped>
.xsxxxgsq {
  height: 100%;
  background-color: #f2f2f4;
  overflow: auto;
  .xsxxxgsq_info {
    position: relative;
    background: #ffffff;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin: 10px 15px;
    .xsxxxgsq_info_header {
      height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px;
      border-bottom: 1px solid #e5e5e5;
      .header_left {
        h3 {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          line-height: 22px;
          color: #333333;
          letter-spacing: 0;
          font-weight: 500;
        }
      }
      .header_right {
        display: flex;
        align-items: center;
        color: #7469f8;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0;
        font-weight: 400;
        .van-icon {
          margin-right: 5px;
        }
      }
    }
    .xsxxxgsq_info_content {
      padding: 13px 15px 15px;
      .content_item {
        display: flex;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 20px;
        & + .content_item {
          margin-top: 8px;
        }
        span {
          white-space: nowrap;
        }
        p {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          font-weight: lighter;
          margin-left: 5px;
          line-height: 20px;
          white-space: wrap;
        }
      }
    }
  }
  .info_person {
    position: relative;
    .info_person_img {
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translate(0, -50%);
      width: 68px;
      height: 90px;
      border: 1px solid #ebebeb;
      border-radius: 4px;

      .img_preview {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        img {
          width: 100%;
          height: 100%;
        }
        .right_icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 18px;
          height: 18px;
          background-color: #7469f8;
          border-radius: 0 0 0 16px;
          .van-icon {
            font-size: 8px;
            color: #fff;
            position: absolute;
            top: 2px;
            right: 2px;
          }
        }
      }

      /deep/.van-uploader {
        width: 100%;
        height: 100%;
        .van-uploader__wrapper {
          width: 100%;
          height: 100%;
          .van-uploader__upload {
            margin: 0;
            width: 100%;
            height: 100%;
          }
        }
        .van-uploader__preview {
          width: 100%;
          height: 100%;
          margin: 0;
          .van-uploader__preview-image {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .info_person_main {
      width: calc(~"100% - 90px");

      h3 {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: bolder;
        line-height: 25px;
        padding: 15px 15px 0;
        margin-bottom: -7px;
      }
      .xsxxxgsq_info_content {
        .content_item {
          color: #999999 !important;
        }
      }
    }
  }
  .xsxxxgsq_info_item {
    position: relative;
    padding: 14px 0;
    h3 {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 22px;
      padding: 0 15px;
      margin-bottom: -5px;
    }
    .van-icon {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translate(0, -50%);
      font-size: 14px;
      color: #333333;
    }
    & + .xsxxxgsq_info_item::before {
      content: "";
      position: absolute;
      top: 0;
      width: calc(~"100% - 30px");
      left: 15px;
      border-top: 1px solid #e5e5e5;
    }
  }
  .back_top {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 8px;
    bottom: 20%;
    width: 40px;
    height: 40px;
    background: #7469f8;
    background-color: #7469f8;
    border-radius: 50%;
    .van-icon {
      color: #fff;
      font-weight: bolder;
      font-size: 25px;
    }
  }
}
// van-tabs
/deep/.van-tabs--line {
  .van-tabs__wrap {
    height: 50px;
    .van-tabs__nav--line {
      padding-bottom: 0;
      margin: 0 -8px;
      .van-tab {
        position: relative;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
        &.van-tab--active {
          color: #333333;
          font-weight: bolder;
        }
      }
      .van-tabs__line {
        background-color: #7469f8;
        bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xsxxxgsq/index.vue